import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type DestinationReportingRoute from 'lumen/routes/destination/reporting';
import type { ModelFrom } from 'lumen/utils/routes';

export default class DestinationReportingController extends Controller {
  declare model: ModelFrom<DestinationReportingRoute>;

  // eslint-disable-next-line ember/no-unused-services
  @service declare customReporting: Services['custom-reporting'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get folders() {
    if (this.model.folders.isRunning) {
      return [];
    }

    const folders = this.model.folders.lastSuccessful?.value;
    const daasFolder = folders?.find((folder) => folder.isEmbedSharedRoot);

    return daasFolder?.folders.filter((f) => !f.isNew) || [];
  }
}
